import set from 'lodash-es/set';



export default class DropBoxComponent {
  constructor(instance) {
    var me = this;
    me.instance = instance;
    if(instance.originalOptions.chartType == 'DropBox'){
      instance.on('binddata',(event,records, re, options)=>{
        set(options,'vars.dropBox.dropBoxName',options.dropBoxName);
        set(options,'vars.dropBox.currentPath',options.currentPath);        
      });
      instance.on('preprocessoptions',(event,options)=>{
        set(options,'controls[2].controls[0].controls[1].value',options.splitterPosition);
      });
      instance.on('ready', () => {

          if(this.treeControl){
            this.treeControl.on('change', this.onTreeChange);          
          }

          if(this.detailsControl){
            this.detailsControl.on('currentPath', this.onDetailsCurrentPath);          
            this.detailsControl.on('entries', this.onDetailsEntries);          
          }
      });
    }
  }

  get treeControl(){
    return this.instance.controls['controls[2].controls[0].controls[0].controls[0]'];
  }

  get detailsControl(){
    return this.instance.controls['controls[2].controls[0].controls[2].controls[0]'];    
  }

  onTreeChange(event, control, component, anchor, data){
    if(anchor && !anchor.entry.isFile){
      const p = anchor.entry.fullPath.split('/');
      p.shift();
      component.dropBoxComponent.detailsControl.currentPath = '/'+p.join('/');    
    } 
  }

  onDetailsCurrentPath(event, control, component, anchor, data) {
    var tree = component.dropBoxComponent.treeControl;    
    if(tree.currentPath!==control.currentPath){
      tree.currentPath=control.currentPath;
    }  
  }

  onDetailsEntries(event, control, component, anchor, data) {  
    //if(data[0],value!==data[0].oldValue){  
    
    // var oldPath = component.getVariable('dropBox.currentPath');
    var newPath = control.currentPath||'/';
    
    //console.log(oldPath,' -> ',newPath);
    component.setVariable('dropBox.currentPath',newPath);
    var stats = control.entries.reduce((res,entry) => {
      if(entry.extension){
        if(!res[entry.extension]){
            res[entry.extension] = {
              name: entry.extension,
              value: entry.sizeBytes,
              size: entry.size
            }
        }else{
          res[entry.extension].value += entry.sizeBytes;
        }   
      }

      return res;
    },{});
    //console.log({stats});
    stats = Object.values(stats);
    if(!stats.length){
      stats.push({
        name: 'empty directory',
        value:0,
        size:''
      });
    }

    component.setVariable('dropBox.stats',stats);
    component.setVariable('dropBox.filesCount', control.entries.filter((entry) => entry.isFile).length + ' files');
    component.refresh();
     
  }

 
}
